import { schema } from "normalizr";
import { gameEntity } from "./game";

export const narrationEntity = new schema.Entity("narrations", {
  gameId: gameEntity,
});
